import { render, staticRenderFns } from "./UpdateCompany.vue?vue&type=template&id=3a728cae&"
import script from "./UpdateCompany.vue?vue&type=script&lang=ts&"
export * from "./UpdateCompany.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateCompany.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports